import {defineStore} from "pinia";

interface AxiosState {
    abortController: AbortController;
}

export const useAxiosStore = defineStore({
    id: 'axios',
    state: () => ({
        abortController: new AbortController(),
    } as AxiosState),
    actions: {
        abort(reason: string) {
            this.abortController.abort(`${reason}, aborting outstanding requests.`);
            this.abortController = new AbortController();
        }
    }
})
